import { Component, Input } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

export interface EditedUnloadData {
    originalData: {attribute: string, value: string}[];
    editedData: {attribute: string, value: string}[];
}

@Component({
  selector: 'app-edited-unload',
  templateUrl: './edited-unload.component.html',
  styleUrls: ['./edited-unload.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class EditedUnloadComponent {
  @Input() show: boolean = false;
  @Input() data: EditedUnloadData = {
    originalData: [],
    editedData: []
  };
  displayedColumns = ['attribute', 'value'];
  columnDefinition = [
    { key: 'attribute', text: "Atributo" },
    { key: 'value', text: "Valor" }
  ];
  
  constructor() {}
} 